/* global axios */
import ApiClient from './ApiClient';

class AiAgentsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  getAiAgents() {
    return axios.get(`${this.url}?type=ai_agent`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }
}

export default new AiAgentsAPI();
